module.exports = __webpack_public_path__ + "img/loading2.2f2ad951.gif";